import React from "react";
import cx from "clsx";
const InputTags = ({
  children
}) => {
  const tagsRef = React.useRef(null);
  React.useEffect(() => {
    const handleMouseMove = event => {
      if (tagsRef && tagsRef.current) {
        // @ts-expect-error TODO
        const {
          isDragging
        } = tagsRef.current;
        if (isDragging && event.movementX) {
          tagsRef.current.scrollLeft -= event.movementX;
        }
      }
    };
    const handleMouseUp = () => {
      if (tagsRef && tagsRef.current) {
        // @ts-expect-error TODO
        tagsRef.current.isDragging = false;
      }
    };
    const tags = tagsRef.current;
    if (tags) {
      // @ts-expect-error TODO
      tags.addEventListener("mousemove", handleMouseMove);
      // @ts-expect-error TODO
      tags.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      if (tags) {
        // @ts-expect-error TODO
        tags.removeEventListener("mousemove", handleMouseMove);
        // @ts-expect-error TODO
        tags.removeEventListener("mouseup", handleMouseUp);
      }
    };
  }, [tagsRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx("relative", "ms-300", "flex flex-initial items-center", "h-full min-w-[50px]", "overflow-hidden", "z-[2]")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("overflow-x-scroll whitespace-nowrap", "space-x-200 flex items-center rtl:space-x-reverse", "scrollbar-none"),
    ref: tagsRef,
    onMouseDown: () => {
      if (tagsRef && tagsRef.current) {
        // @ts-expect-error TODO
        tagsRef.current.isDragging = true;
      }
    }
  }, children));
};
export default InputTags;